module.exports = __webpack_public_path__ + "static/img/ybzxwp.66b86991.png";